import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './hooks/useAuth';
import { ThemeProvider } from './hooks/useTheme';
import { usePushNotifications } from './hooks/usePushNotifications';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Fuhrpark from './pages/Fuhrpark';
import Kalender from './pages/Kalender';
import Schaden from './pages/Schaden';
import SchadenQR from './pages/SchadenQR';
import FahrzeugQR from './pages/FahrzeugQR';
import Packliste from './pages/Packliste';
import PacklisteDetail from './pages/PacklisteDetail';
import Benutzer from './pages/Benutzer';
import Einstellungen from './pages/Einstellungen';
import AdminBackup from './pages/AdminBackup';
import EmailVerwaltung from './pages/EmailVerwaltung';
import './assets/global.css';

function PrivateRoute({ children, permission }) {
  const { user, loading, can } = useAuth();
  // Warten bis Auth-State geladen — verhindert falschen Redirect
  if (loading) return (
    <div style={{ minHeight:'100dvh', display:'flex', alignItems:'center', justifyContent:'center', background:'var(--bg)' }}>
      <div className="spinner" style={{ width:36, height:36, borderWidth:3 }} />
    </div>
  );
  if (!user) return <Navigate to="/login" replace />;
  if (permission && !can(permission)) return <Navigate to="/dashboard" replace />;
  return children;
}

// PushManager läuft im Hintergrund — startet Polling und verwaltet SW
function PushManager() {
  usePushNotifications();
  return null;
}

function AppRoutes() {
  const { user } = useAuth();
  return (
    <>
      {user && <PushManager />}
      <Routes>
        <Route path="/login"      element={user ? <Navigate to="/dashboard" replace /> : <Login />} />
        <Route path="/dashboard"  element={<PrivateRoute><Dashboard /></PrivateRoute>} />
        <Route path="/fuhrpark"   element={<PrivateRoute permission="fuhrpark"><Fuhrpark /></PrivateRoute>} />
        <Route path="/fuhrpark/:vehicleId/qr/schaden"   element={<PrivateRoute><FahrzeugQR /></PrivateRoute>} />
        <Route path="/fuhrpark/:vehicleId/qr/packliste" element={<PrivateRoute><FahrzeugQR /></PrivateRoute>} />
        <Route path="/fuhrpark/:vehicleId/qr"           element={<PrivateRoute><FahrzeugQR /></PrivateRoute>} />
        <Route path="/kalender"   element={<PrivateRoute><Kalender /></PrivateRoute>} />
        <Route path="/schaden"    element={<PrivateRoute><Schaden /></PrivateRoute>} />
        <Route path="/schaden/qr/:vehicleId" element={<PrivateRoute><SchadenQR /></PrivateRoute>} />
        <Route path="/packliste"  element={<PrivateRoute><Packliste /></PrivateRoute>} />
        <Route path="/packliste/:id" element={<PrivateRoute><PacklisteDetail /></PrivateRoute>} />
        <Route path="/benutzer"   element={<PrivateRoute permission="benutzer_manage"><Benutzer /></PrivateRoute>} />
        <Route path="/einstellungen" element={<PrivateRoute><Einstellungen /></PrivateRoute>} />
        <Route path="/admin/backup"  element={<PrivateRoute permission="benutzer_manage"><AdminBackup /></PrivateRoute>} />
        <Route path="/email"          element={<PrivateRoute><EmailVerwaltung /></PrivateRoute>} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ThemeProvider>
          <AppRoutes />
          <Toaster
            position="top-center"
            toastOptions={{
              duration: 3500,
              style: {
                background: 'var(--bg-card)',
                color: 'var(--text)',
                border: '1px solid var(--border)',
                borderRadius: '10px',
                fontSize: '0.875rem',
                fontFamily: 'Inter, -apple-system, sans-serif',
                boxShadow: '0 8px 24px rgba(0,0,0,.12)',
                maxWidth: '400px',
              },
              success: { iconTheme: { primary: '#16a34a', secondary: '#fff' } },
              error:   { iconTheme: { primary: '#e63946', secondary: '#fff' } },
            }}
          />
        </ThemeProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
